import { all, fork } from 'redux-saga/effects'

// admin
import admin from '@redux/saga/admin/admin.saga'
import adminUsers from '@redux/saga/admin/adminUsers.saga'
import accessControl from '@redux/saga/admin/accessControl.saga'
import logDashboard from '@redux/saga/admin/logDashboard.saga'
// @PLOP-IMPORTS

export default function* rootSaga() {
	yield all([
		fork(admin),
		fork(adminUsers),
		fork(accessControl),
		fork(logDashboard),
		// @PLOP-CODE
	])
}
